import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed against the shipping mobile app's API client (2026-10-22): these
// GETs send their filters wrapped as params: { data: {...} }, not flat query
// params — sending them flat is what was causing the backend's
// Validator::make() to receive null and 500.
export const getAttendance = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.ATTENDANCE.GET, { params: { data: params } });
  return response;
};

export const getAttendanceSummary = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.ATTENDANCE.GET_SUMMARY, { params: { data: params } });
  return response;
};
